<template>
  <div>
    <div class="taskBox">
      <div class="headerTop" v-if="ApiMyLevel && !autoload">
        <div class="leaves">
          Lv <span>{{ ApiMyLevel.level }}</span>
        </div>
        <div class="task_greeds">
          <span>{{ ApiMyLevel.exp }}/{{ ApiMyLevel.nextLevelExp }} (还需要 {{ ApiMyLevel.nextLevelExp - ApiMyLevel.exp }} 经验值升级到L{{ ApiMyLevel.level + 1 }})</span>
          <div class="task_progress">
            <el-progress :show-text="false" :stroke-width="6" class="el-bg-inner-running" :percentage="fifpercentage(ApiMyLevel)"></el-progress>
          </div>
        </div>
      </div>
      <div class="task_Bg" :class="autoload?'maxHeights':''">
        <div class="task_items" v-if="!activeOverState">
          <span class="task_itemsTitle">看直播领宝箱</span>
          <div class="task_itemsContent" >
            <div class="task_itemsContentitem" v-for="(item, index) in treasureBox" :key="index" :class="{ shake: item.treasureBoxRecordVO.completeState == 1 }">
              <div class="task_itemsContent_top">
                <img v-if="item.treasureBoxRecordVO.completeState != 2" class="baopacket" src="/static/newcenter/packtask.webp" alt="" srcset="" />
                <div class="alerdyBao" v-if="item.treasureBoxRecordVO.completeState == 2">
                  <div class="alerdyBao_items">
                    <img src="/static/newcenter/jingyan.webp" alt="" srcset="" />
                    <span>+{{ item.treasureBoxConfigVO.awardExp }}</span>
                  </div>
                  <div class="alerdyBao_items" style="margin-top: 6px">
                    <img src="/static/newcenter/beike.webp" alt="" srcset="" />
                    <span>+{{ item.treasureBoxConfigVO.awardAmount }}</span>
                  </div>
                </div>
              </div>
              <div class="btnStatusTime">
                <span class="ToReceive1 hasGet" v-if="item.treasureBoxRecordVO.completeState == 2"> 已领取 </span>
                <span v-else-if="item.treasureBoxRecordVO.completeState == 1" class="canGet" @click="getPrizeVideo(item.treasureBoxRecordVO)"> 领取 </span>
                <span v-else-if="item.treasureBoxRecordVO.completeState == 0" class="noStart">
                  <template v-if="item.hasCountdown"> {{ taskBoxCountdownTime }} </template>
                  <template v-else> 未开始 </template>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 宝箱领取完成 -->
        <div class="activeTeskBox" v-else>
          <div class="activeTeskBoxCnt">
            <div class="activeTeskBoxitem">
              <div class="activeName">今日宝箱已领完</div>
              <div class="activeDis">活动已开启：实物抱枕、球衣等送不停</div>
              <div class="addJoinActive" @click="addActive">
                立即参加
              </div>
            </div>
            <div class="Toimgs">
              <el-carousel height="76px" :autoplay="true" arrow='never' indicator-position='none'>
                  <el-carousel-item >
                    <div >
                      <img src="/static/newcenter/activeBg.png" alt="">
                    </div>
                  </el-carousel-item>
                  <el-carousel-item >
                    <div >
                      <img src="/static/newcenter/activeBg2.png" alt="">
                    </div>
                  </el-carousel-item>
                </el-carousel>
            </div>
          </div>
          <img class="zimus" src="/static/newcenter/groups.png" alt="" srcset="">

        </div>
        <div class="taskListHeight" v-if="!autoload">
          <div class="taskListItem" v-for="(item, index) in userTesk" :key="index">
            <div class="taskitemName">
              <div class="Titles">{{ item.userTaskConfigVO.taskTitle }}</div>
              <div class="labelsaddexp">
                <div class="labelsaddexpbox">
                  <img src="/static/newcenter/jingyan.webp" alt="" />
                  <span>+{{ item.userTaskConfigVO.awardExp }}</span>
                </div>
                <div class="labelsaddexpbox" v-if="item.userTaskConfigVO.awardAmount">
                  <img src="/static/newcenter/beike.webp" alt="" />
                  <span>+{{ item.userTaskConfigVO.awardAmount }}</span>
                </div>
              </div>
            </div>
            <div class="ToreceiveTeak">
              <span class="status1" v-if="item.userTaskRecordVO.completeState == 0" @click="Tocomplete(item.userTaskConfigVO.taskType)"> 去完成 </span>
              <span v-if="item.userTaskRecordVO.completeState == 1" @click="getPrizeTask(item.userTaskConfigVO)"> 领取 </span>
              <span class="status2" v-if="item.userTaskRecordVO.completeState == 2"> 已完成 </span>
            </div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>


  </div>
</template>

<script>
import { userTaskList, treasureBoxlist ,treasureBoxReport, levelAndExp,taskacquireAward,acquireAward,configList} from "@/api/fans.js";
// import { Result } from "element-ui";
import { myLocalStorage } from "@/lib/tools.js";
// import { formatDate3 } from "@/utils/fn";
// import Api from "@/utils/api";
import moment from 'moment'
export default {
  props:{
    autoload:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      // 任务列表
      userTesk: [],
      // 宝箱任务列表
      treasureBox: [],
      ListTask: [
        {
          ToReceive: 1, // 领取状态
        },
        {
          ToReceive: 2, // 领取状态
        },
        {
          ToReceive: 3, // 领取状态
        },
        {
          ToReceive: 4, // 领取状态
        },
        {
          ToReceive: 4, // 领取状态
        },
        {
          ToReceive: 4, // 领取状态
        },
      ],
      taskBoxCountdownTime: null,
      taskBoxCountdownCurr: null,
      taskBoxViewerTime: 0, //观看时长
      taskBoxCurrId: null,
      interval1: null,
      ApiMyLevel: {},
      activeOverState:false,
      iframeUrl:'' // http://t-new.longzhu.com/act/#/activity/1?t=xxxx
    };
  },
  created() {
    console.log('加载宝箱数据',this.autoload);
    if(this.autoload && localStorage.getItem('token')){
      // 获取宝箱列表
      this.getbaoBoxList();
    }
  },
  methods: {
    open(){
      if(localStorage.getItem('token')){
        this.initData();
      }
    },
    fifpercentage(ApiMyLevel){
      console.log('经验值变化', ApiMyLevel.exp / ApiMyLevel.nextLevelExp);
      return  parseFloat( ApiMyLevel.exp / ApiMyLevel.nextLevelExp ) * 100 || 0
    },
    //获取经验值
    getMyLevel() {
      console.log(this.$route.name);
      levelAndExp({}).then((res) => {
        if (res.data.code == 200) {
          this.ApiMyLevel = res.data.data;
        }
      });
    },
    //上报时长
    setPrizeBoxReport() {
      // this.taskBoxViewerTime
      let totalNum = parseInt(localStorage["taskBoxViewerTime"]);
      treasureBoxReport({ viewTimes: totalNum, taskId: this.taskBoxCurrId }).then((res) => {
        if (res.data.code == 200) {
         this.treasureBox[this.taskBoxCountdownCurr].treasureBoxRecordVO.completeState = 1; //变成 可领取
         myLocalStorage.set("userTaskList", "room",this.treasureBox);
        }
      });
    },
   // 处理倒计时和时间格式
    formatDate3(sec) {
      let d1;
      // 减去本地存储的剩余的时间
      if (!!isNaN(localStorage["taskBoxViewerTime"])) localStorage["taskBoxViewerTime"] = 0;
      sec = sec - parseInt(localStorage["taskBoxViewerTime"]);
      console.log("减去本地存储的剩余的时间", sec);
      let fn = () => {
        if (sec <= 0) {
          clearInterval(window["interval1"]);
          this.setPrizeBoxReport(); //上报任务做的时间
          this.$store.dispatch('setboxTimes',{
            times:0,
            type:2
          })
        } else {
          d1 = new Date(sec * 1000);
          let m = d1.getMinutes() >= 10 ? d1.getMinutes() : "0" + d1.getMinutes();
          let s = d1.getSeconds() >= 10 ? d1.getSeconds() : "0" + d1.getSeconds();
          this.taskBoxCountdownTime = m + ":" + s;
          if (this.$route.name === "roominfo") {
            sec--;
            localStorage["taskBoxViewerTime"] = parseInt(localStorage["taskBoxViewerTime"]) + 1;
            this.$store.dispatch('setboxTimes',{
              times:this.taskBoxCountdownTime,
              type:1
            })
          }
        }
        console.log("任务--观看时长：", localStorage["taskBoxViewerTime"]);
      };
      clearInterval(window["interval1"]);
      if (this.$route.name === "roominfo") {
        window["interval1"] = setInterval(fn, 1000);
      }
      fn();
    },
    // 领取任务
    getPrizeTask({ taskId }) {
      taskacquireAward({ taskId: taskId }).then((res) => {
        if (res.data.code == 200) {
          this.refreshMoney()
          this.$message({ message: "领取成功", type: "success" });
          this.getuserTaskList();
          this.getMyLevel();
        }else {
           this.$message({ message: res.data.message, type: "error" });
        }
      });
    },
    // 刷新贝壳
    refreshMoney(){
       this.$store.dispatch('getUserMoneyData', 2);
    },
    // 领取宝箱任务
    getPrizeVideo({ taskId }) {
      acquireAward({ taskId: taskId }).then((res) => {
        if (res.data.code == 200) {
          localStorage["taskBoxViewerTime"] = 0;
          if(res.data.code == 19005){
            this.$message({ message: "该宝箱已被领取", type: "success" });
          }else{
            this.$message({ message: "领取成功", type: "success" });
          }
          this.treasureBox.map((item,index)=>{
            if(item.treasureBoxConfigVO.taskId == taskId){
              item.treasureBoxRecordVO.completeState = 2
            }
            return item
          })
          console.log('领取后状态',this.treasureBox);
          myLocalStorage.set("userTaskList", "room",this.treasureBox);
          this.taskBoxCountdownTime = null;
          this.taskBoxCountdownCurr = null;
          this.taskBoxCurrId = null;
          clearInterval(window["interval1"]);
          this.refreshMoney()
          setTimeout(()=>{
            this.getbaoBoxList(2);
          })
          this.getMyLevel();
        }else if(res.data.code >= 19003 || res.data.code <= 19012){
          this.$message({ message: res.data.message, type: "error" });
          this.getbaoBoxList(2);
        } else {
          this.$message({ message: res.data.message, type: "error" });
        }
      });
    },
    // 处理宝箱任务状态
    formatBox() {
      console.log("处理宝箱任务状态");

      let num = 0
      let o1 = this.treasureBox;
      for (var i = 0; i < o1.length; i++) {
        if (o1[i].treasureBoxRecordVO.completeState === 1) {
          // 如果有待领取
          console.log("如果有待领取");
          this.$store.dispatch('setboxTimes',{
            times:'',
            type:2
          })
          break;
        } else if (o1[i].treasureBoxRecordVO.completeState === 0) {
          //第一个未开始
          console.log("第一个未开始");
          this.taskBoxCurrId = o1[i].treasureBoxConfigVO.taskId;
          this.taskBoxCountdownCurr = i;
          this.formatDate3(o1[i].treasureBoxConfigVO.viewTimesTarget);
          o1[i].hasCountdown = true;

          break;
        } else {
         num++
        }
        if(num == this.treasureBox.length ){
          this.$store.dispatch('setboxTimes',{
            times:'',
            type:3
          })
          this.getActiveList();
          console.log('宝箱全部领取完毕');
        }

      }
      this.treasureBox = o1;
      myLocalStorage.set("userTaskList", "room",this.treasureBox);
    },
    addActive(){
      this.$emit('openiframe',  this.iframeUrl)
    },
    // 检查活动
    getActiveList(){
      configList({}).then(result=>{
        if(result.data.code == 200){
          console.log('当前任务活动',result.data.data);
          let arrs =  result.data.data
          arrs.map(item=>{
            let {activityType,state} =item;
            let token  = localStorage.getItem('token')
            if(activityType == 1 ){
              if(state == 0){
                this.activeOverState = true;
                this.iframeUrl = ` http://t-new.longzhu.com/act/#/activity/1?plat=pc&t=${token}`
              }
            }
          })
        }else{
          console.log('检查活动',result.data.message);
        }
      })

    },
    Tocomplete(v) {

      console.log('去完成任务的',v);
      // 1：成功修改昵称，2：成功修改头像，3：首次充值，4：首次送礼，5：首次关注主播，6：首次发送弹幕
      this.$emit('changeDialog',v)
    },
    opentesk() {},
    // getTeskList() {
    //   const params = myLocalStorage.get("userTaskList", "home");
    //   if (!params) {
    //     // 轮播图
    //     banners({
    //       pcatId: 1,
    //     }).then((res) => {
    //       if (res.data.code == 200) {
    //         this.bannerList = res.data.data;
    //         myLocalStorage.set("userTaskList", "home", this.bannerList);
    //       }
    //     });
    //   } else {
    //     this.bannerList = params;
    //   }
    // },
    // 获取宝箱列表
    getbaoBoxList(type = 0) {
      console.log("任务---处理倒计时和时间格式",this.taskBoxCountdownTime);
      const params = myLocalStorage.get("userTaskList", "room");
      let DayTime = localStorage.getItem('DayTime');
      let nowDay = moment().format('YYYY-MM-DD');
      // 没有数据 或者过期
      if (!params || nowDay != DayTime || type >0) {
        treasureBoxlist({}).then((res) => {
          if (res.data.code == 200) {
            localStorage["taskBoxViewerTime"] = 0;
            this.treasureBox = res.data.data;
            myLocalStorage.set("userTaskList", "room",this.treasureBox);
            this.formatBox();
             localStorage.setItem('DayTime',moment().format('YYYY-MM-DD'));
            console.log("宝箱的任务列表1", this.treasureBox);
          }
        });
      } else {
        this.treasureBox = params;
        this.formatBox();
        console.log("宝箱的任务列表2", this.treasureBox);
      }
    },
    // 获取任务列表
    async getuserTaskList() {
      let result = await userTaskList({});
      if (result.data.code == 200) {
        let userTesk = result.data.data;
        // 过滤已完成任务
        this.userTesk = userTesk.filter((item, index) => {
          // 过滤已领取的任务
          if (item.userTaskRecordVO.completeState <= 2) {
            return true;
          }
        });
        console.log("任务列表", this.userTesk);
      }

    },
    async initData() {
      // 获取宝箱列表
      this.getbaoBoxList();
      // 获取任务列表
      this.getuserTaskList();
      // 获取经验值
      this.getMyLevel();
    },
  },
};
</script>

<style lang="scss" scoped>
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;

  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border: 0;
  }


.taskBox {
  background: #f7f8fa;
  box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
  border-radius: 0px 0px 6px 6px;
  text-align: left;
  border-radius: 6px;
  overflow: hidden;
  .headerTop {
    width: 400px;
    height: 120px;
    background: #721edc;
    border-radius: 2px 2px 0px 0px;
    padding: 12px;
    box-sizing: border-box;
  }
  .activeTeskBox{
    justify-content: space-between;
    border-radius: 4px;
    overflow: hidden;
    background-image:url('/static/newcenter/activesbg.png');
    background-size: 100%;
    background-repeat: no-repeat;
    // width: 376px;
    height: 125px;
    position: relative;
    padding: 8px;
    box-sizing: border-box;
    .activeTeskBoxCnt{
      background: #FFFFFF;
      display: flex;
      height: 109px;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 12px;
    }
    .zimus{
      position: absolute;
      bottom: 6px;
      right: 9px;
      width: 200px;
      height: 16px;
      z-index: 99;
    }
    .Toimgs{
       width: 78px;
       height: 78px;
       border-radius: 3px;
       border: 1px solid #F07839;
      img{
        width: 76px;
        height: 76px;
      }
    }
    .activeTeskBoxitem{

      flex: 2;
      display: flex;
      flex-direction: column;
      .activeDis{
        margin-top: 3px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 17px;

      }
      .addJoinActive{
        width: 83px;
        cursor: pointer;
        text-align: center;
        height: 26px;
        line-height: 26px;
        background: linear-gradient(270deg, #FFA829 0%, #FF8729 100%);
        border-radius: 15px;
        margin-top: 8px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
      }
      .activeName{
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #E85416;
          line-height: 25px;
      }
    }

  }
  .taskListHeight {
    max-height: 250px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .maxHeights{
    transform: translateY(0) !important;
    padding:0 !important ;
    border-radius: 5px;
    overflow: hidden;
  }
  .task_Bg {
    transform: translateY(-38px);
    max-height: 350px;
    padding: 12px;
    .taskListItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 6px;
      padding: 12px;
      width: 376px;
      background: #ffffff;
      border-radius: 4px;
      box-sizing: border-box;
      .ToreceiveTeak {
        color: #ffffff;
        span {
          border-radius: 27px;
          background: #721edc;
          display: inline-block;
          text-align: center;
          line-height: 28px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          width: 60px;
          cursor: pointer;
          height: 28px;
        }
        .status1 {
          background: #fff;
          border: 1px solid #721edc;
          color: #721edc;
        }
        .status2 {
          background: #e6eefd;
          color:#333;
        }
      }
      .labelsaddexp {
        display: flex;
        align-items: center;
        .labelsaddexpbox {
          margin-top: 12px;
          margin-right: 12px;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
          }
          span {
            margin-left: 2px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
          }
        }
      }
      .taskitemName {
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .Titles {
          height: 16px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 16px;
        }
      }
    }
    .task_items {
      padding: 12px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      min-width: 376px;
      height: 125px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
    }
    .task_itemsTitle {
      height: 18px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333;
      line-height: 18px;
    }
    .task_itemsContent {
      margin-top: 12px;
      display: flex;
      height: 125px;
      background: #ffffff;
      border-radius: 4px;
      .task_itemsContentitem {
        margin-right: 14px;
        min-width: 47px;
      }
      .task_itemsContentitem:last-child{
        margin-right: 0px !important;
      }
      .labelsName {
        display: flex;
      }

      .btnStatusTime {
        margin-top: 6px;
        .ToReceive2 {
          background: #721edc;
          color: #fff;
        }

        span {
          width: 48px;
          height: 22px;
          background: #e6eefd;
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
        .canGet {
          background: #721edc;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .task_itemsContent_top {
      .baopacket {
        width: 47px;
        height: 39px;
      }
      .alerdyBao {
        width: 48px;
        height: 43px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .alerdyBao_items {
          display: flex;
          align-items: center;
        }
        img {
          width: 16px;
          height: 16px;
        }

        span {
          margin-left: 2px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
        }
      }
    }
  }
  .leaves {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .task_greeds {
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.task_progress {
  /* 渐变进度条 */
  margin-top: 8px;
  .el-bg-inner-running .el-progress-bar__inner {
    background: #fff;
  }
  .el-progress-bar__outer {
    background: rgba(255, 255, 255, 0.3);
  }
}
.shake {
  .task_itemsContent_top {
    animation: shake1 350ms ease-in-out 0s infinite alternate;
  }
}
@keyframes shake1 {
  0% {
    transform: translateY(0rpx);
  }
  100% {
    transform: translateY(10rpx);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_receivetask.vue